module.exports = __webpack_public_path__ + "01ea978f/img/file-icon.c085e21e.svg";